import React, { useState } from 'react'
import styled from 'styled-components'
import { PageType } from '../interfaces/types'
import Sidebar from '../Sidebar'
import hamburger from './hamburger.svg'

const StyledDiv = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 48px;
  background-color: #0548CB;

  display: flex;
  justify-content: left;
  align-items: baseline;

  gap: 10px;

  padding: 10px;
  
  box-sizing: border-box;

  z-index: 100;

  * {
    user-select: none;
  }

  h1 {
    margin: 0;
    font-size: 24px;
    color: white;
    font-family: 'GMarketSansBold';
  }

  .description {
    font-size: 14px;
    font-family: 'GMarketSansMedium';
    color: white;
    flex-grow: 1;
  }
`

const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 900;
`

const Navigation = (
  props: {
    setCurrentPage: (page: PageType, path?: string) => void,
  }
) => {

  const [sidebarVisibility, setVisibility] = useState(false)

  const sidebarShow = () => {
    setVisibility(true)
  }

  return (
    <>
    {
      sidebarVisibility && (
        <Background
          onClick={(e) => {
            e.preventDefault()
            setVisibility(false)}}
        >
          <Sidebar
            setCurrentPage={props.setCurrentPage}
          ></Sidebar>
        </Background>
      )
    }
    <StyledDiv>
      <h1>이대호</h1>
      <div className='description'>
        90년생 직장인 성남시장</div>
      <button
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          outline: 'none',
          cursor: 'pointer',
        }}
        onClick={sidebarShow}
      >
        <img src={hamburger} alt='hamburger' />
      </button>
    </StyledDiv>
    </>
  )
}

export default Navigation